import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { useForm } from "react-hook-form"
import { Grid, TextField, Typography } from "@mui/material"
import { toast } from "react-toastify"
import { getHawaiiShippingAddress } from "src/features/checkout/checkoutSlice"
import { SPECIAL_EVENTS, SPECIAL_EVENTS_DATA } from "src/app/constants"
import useUpdateEmailAndShippingAddress from "src/app/hooks/useUpdateEmailAndShippingAddress"
import Addons from "../addons/Addons"
import BackAndNextButton from "../common/BackAndNextButton"
import EmailInput from "../common/EmailInput"
import PhoneInput from "../common/PhoneInput"
import TextInput from "../common/TextInput"
import InformationHeader from "./InformationHeader"
import analytics from "src/app/analytics"

function BottomNav({ loading }) {
  return (
    <BackAndNextButton
      loading={loading}
      // backButtonLabel="Return to options"
      backButtonPath="../options"
      nextButtonLabel="Continue to delivery"
      nextButtonPath="../delivery"
      nextButtonType="submit"
    />
  )
}

export default function SpecialEventsForm() {
  const navigate = useNavigate()
  const {customer, cart} = useSelector((state) => state.checkout)
  const specialEvent = useSelector(
    (state) => state.checkout.options.specialEvent,
  )

  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: customer.email || cart.buyerIdentity?.email || "",
      firstName: cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.firstName || "",
      lastName: cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.lastName || "",
      phone: cart.buyerIdentity?.deliveryAddressPreferences?.[0]?.phone || "",
    },
  })

  const [
    updateEmailAndShippingAddress,
    {
      isLoading,
      data: updateEmailAndShippingAddressData,
      error: updateEmailAndShippingAddressError,
    },
  ] = useUpdateEmailAndShippingAddress()

  const onSubmit = async ({ email, ...shippingAddressData }) => {
    const shippingAddress = getHawaiiShippingAddress({
      ...shippingAddressData,
      ...SPECIAL_EVENTS_DATA[specialEvent].shippingAddress,
    })
    const { firstName, lastName, ...shipping_address } = shippingAddress

    analytics.setUserProperties({
      email,
    })

    analytics.track("add_shipping_info", {
      cart_id: cart.id,
      email,
      first_name: firstName,
      last_name: lastName,
      ...shipping_address,
      special_event: specialEvent,
    })

    await updateEmailAndShippingAddress({ email, shippingAddress }).then((res) => {
      console.log('updateEmailAndShippingAddressData', {updateEmailAndShippingAddressData, res})
      if (updateEmailAndShippingAddressData?.cartBuyerIdentityUpdate?.userErrors?.length > 0) {
        toast.error(updateEmailAndShippingAddressData.cartBuyerIdentityUpdate.userErrors[0].message)
        return
      }

      if (updateEmailAndShippingAddressData?.cartBuyerIdentityUpdate?.cart) {
        navigate("../delivery")
      }
    })
  }

  useEffect(() => {
    if (updateEmailAndShippingAddressError?.data?.message) {
      toast.error(updateEmailAndShippingAddressError.data.message)
    }
  }, [updateEmailAndShippingAddressError])

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <InformationHeader />

      {!customer?.id && (
        <>
          <Typography variant="h6">Who's Buying</Typography>
          <Typography color="text.secondary" variant="subtitle1">
            (Buyers Information)
          </Typography>
          <EmailInput
            name="email"
            control={control}
            label="Purchaser's Email Address"
            requiredErrorMessage="Please enter purchaser's email address."
            size="small"
            fullWidth
            sx={{ my: 2 }}
          />
        </>
      )}

      <Typography variant="h6">
        {specialEvent === SPECIAL_EVENTS.ASRC_WAKE_ISLAND
          ? "To whom are we sending this on wake island?"
          : "What name is the reservation under?"}
      </Typography>
      <Typography color="text.secondary" variant="subtitle1">
        (Delivery Information)
      </Typography>

      <Grid container spacing={2} mt={0} mb={2}>
        <Grid item xs={12} sm={6}>
          <TextInput
            name="firstName"
            control={control}
            rules={{
              required: {
                message: "Please enter recipient's first name.",
                value: true,
              },
            }}
            label="Recipient's First Name"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextInput
            name="lastName"
            control={control}
            rules={{
              required: {
                message: "Please enter recipient's last name.",
                value: true,
              },
            }}
            label="Recipient's Last Name"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>

      <TextField
        label="Address"
        size="small"
        value={SPECIAL_EVENTS_DATA[specialEvent].displayAddress}
        fullWidth
        disabled
        sx={{ mb: 2 }}
      />

      <PhoneInput
        control={control}
        label="Recipient's Phone Number"
        size="small"
        fullWidth
        sx={{ mb: 0.5 }}
      />

      <BottomNav loading={isLoading} />

      <Addons />

      <BottomNav loading={isLoading} />
    </form>
  )
}
